import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { DIFFERENTIATORS } from "@/data/content";

const toSlug = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const PullQuote = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [48, -48]);
  return (
    <div ref={ref} data-testid="brand-pull-quote" className="mt-24 text-center">
      <motion.div style={{ y }}>
        <div className="hairline-gold mx-auto w-24 opacity-60" aria-hidden="true" />
        <p className="mx-auto mt-10 max-w-3xl font-display text-3xl font-light italic leading-snug text-slate-100 sm:text-4xl">
          &ldquo;The right capital. The right structure. The right
          source.&rdquo;
        </p>
        <p className="mt-6 font-mono2 text-[10px] uppercase tracking-[0.35em] text-[#F2824F]">
          Jeet Advisory Services
        </p>
        <div className="hairline-gold mx-auto mt-10 w-24 opacity-60" aria-hidden="true" />
      </motion.div>
    </div>
  );
};

const WhyJeet = () => (
  <section
    id="why-jeet"
    data-testid="why-jeet-section"
    className="border-t border-white/5 bg-[#0B0F17]"
  >
    <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
      <SectionHeading
        number="06"
        label="Why Jeet"
        title="Why Jeet Advisory Services"
      />

      <div className="mt-16 grid grid-cols-1 gap-x-16 gap-y-12 md:grid-cols-2">
        {DIFFERENTIATORS.map((d, i) => (
          <Reveal key={d.title} delay={i * 0.07}>
            <div
              data-testid={`differentiator-${toSlug(d.title)}`}
              className="group border-l border-white/10 pl-8 transition-colors duration-500 hover:border-[#F26122]/60"
            >
              <span className="font-mono2 text-[10px] tracking-[0.25em] text-[#F2824F]">
                0{i + 1}
              </span>
              <h3 className="mt-3 font-display text-xl font-normal text-slate-100 sm:text-2xl">
                {d.title}
              </h3>
              <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-slate-400">
                {d.description}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <PullQuote />
    </div>
  </section>
);

export default WhyJeet;
